(function () {
	const storageKey = 'find-your-adventure-user';

	function createUserDataObject() {
		return {
			votes: [],
		};
	}

	function loadData() {
		var userData = window.ysStorage.Get(storageKey);
		var data = createUserDataObject();

		if (!userData || typeof userData !== 'object') {
			return data;
		}

		if (
			userData.votes &&
			typeof userData.votes === 'object' &&
			userData.votes.length > 0
		) {
			for (var i = 0; i < userData.votes.length; i++) {
				var element = userData.votes[i];
				if (
					element.round &&
					typeof element.round === 'number' &&
					element.id &&
					typeof element.id === 'number' &&
					element.time &&
					typeof element.time === 'number'
				) {
					data.votes.push(element);
				}
			}
		}

		return data;
	}

	this.UserDataService = function (plugin) {
		this.data = loadData();
		this.plugin = plugin;

		this.save = function () {
			window.ysStorage.Set(storageKey, this.data);
		}.bind(this);
	};

	function createVote(round, adventureId) {
		return {
			round: round,
			id: adventureId,
			time: Math.round(Date.now() / 1000),
		};
	}

	this.UserDataService.prototype.HasEverVoted = function () {
		return this.data.votes.length > 0;
	};

	this.UserDataService.prototype.HasVotedForRound = function (round) {
		if (!this.HasEverVoted()) {
			return false;
		}

		let adventureRound = parseInt(round, 10);
		if (!adventureRound || isNaN(adventureRound)) {
			throw new Error('adventure.invalidRound');
		}

		return this.data.votes.some(function (vote) {
			return vote.round === adventureRound;
		});
	};

	this.UserDataService.prototype.HasVotedForAdventure = function (id) {
		let adventureId = parseInt(id, 10);
		if (!adventureId || isNaN(adventureId)) {
			throw new Error('adventure.invalidId');
		}

		return this.data.votes.some(function (vote) {
			return vote.id === adventureId;
		});
	};

	this.UserDataService.prototype.CleanupVotes = function () {
		var today = Math.floor(Date.now() / 1000 / 8600);
		this.data.votes = this.data.votes.filter(function (vote) {
			var dayOfVote = Math.floor(vote.time / 8600);
			return dayOfVote >= today;
		});
		this.save();
	};

	this.UserDataService.prototype.AddVote = function (round, id) {
		let adventureRound = parseInt(round, 10);
		if (!adventureRound || isNaN(adventureRound)) {
			throw new Error('adventure.invalidRound');
		}

		let adventureId = parseInt(id, 10);
		if (!adventureId || isNaN(adventureId)) {
			throw new Error('adventure.invalidId');
		}

		this.CleanupVotes();
		this.data.votes.push(createVote(adventureRound, adventureId));
		this.save();
	};

	this.UserDataService.prototype.RemoveVote = function (round, id) {
		let adventureRound = parseInt(round, 10);
		if (!adventureRound || isNaN(adventureRound)) {
			throw new Error('adventure.invalidRound');
		}

		let adventureId = parseInt(id, 10);
		if (!adventureId || isNaN(adventureId)) {
			throw new Error('adventure.invalidId');
		}

		this.data.votes = this.data.votes.filter(function (vote) {
			return !(vote.round === adventureRound && vote.id === adventureId);
		});
		this.save();
	};
}).bind(window.FindYourAdventure)();